import React, { useEffect, useRef, useState } from "react";
import BackButton from "../../components/common/BackButton";
import Loader from "../../components/common/Loader";
import ICButton from "../../core-component/ICButton";
import {
  addCertificateIcon,
  editProfileIcon,
} from "../../assets/icons/SvgIconList";
import UseTranslationHook from "../../hooks/UseTranslationHook";
import {
  ITrainerAvailability,
  fetchServiceDdl,
  fetchTrainerAvailabilityApi,
  handleDeleteTrainerAvailability,
  handleHasTrainerBankInfo,
} from "./TrainerAvailabilityController";
import { dateFormat, getLocalDate } from "../../utils/AppFunctions";
import TrainerAvailabilityFormView from "./TrainerAvailabilityFormView";
import ICSweetAlertModal from "../../core-component/ICSweetAlertModal";
import ICDropDown from "../../core-component/ICDropDown";
import { IDDL, IPagination } from "../../data/AppInterface";
import usePaginationHook from "../../hooks/UsePaginationHook";
import { PAGINATION_PER_PAGE_ROWS } from "../../utils/AppConstants";
import { TScrollEvent } from "../../data/AppType";
import NoData from "../../components/common/NoData";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { routeTrainer } from "../../routes/RouteTrainer";
import { BIT_VALUE } from "../../utils/AppEnumerations";

const TrainerAvailabilityView = () => {
  const { t } = UseTranslationHook();
  const navigate = useNavigate();
  const listInnerRef = useRef<HTMLDivElement>(null);
  let timer: NodeJS.Timeout;
  const [loading, setLoading] = useState(true);
  const [trainerAvailabilityList, setTrainerAvailabilityList] = useState<
    ITrainerAvailability[]
  >([]);
  const [trainerAvailabilityToEdit, setTrainerAvailabilityToEdit] =
    useState<ITrainerAvailability>();
  const [showForm, setShowForm] = useState(false);
  const [servicesDdl, setServicesDdl] = useState<IDDL[]>([]);
  const [selectedRelationId, setSelectedRelationId] = useState<number>();
  const [showHistoricalCheck, setShowHistoricalCheckCheck] =
    useState<boolean>();
  const [hasBankInfo, setHasBankInfo] = useState(false);
  const [loadingBankInfoDetails, setLoadingBankInfoDetails] = useState(true);
  const { pagination, setPagination } = usePaginationHook({
    pagination: {
      per_page_rows: Number(PAGINATION_PER_PAGE_ROWS.Ten),
      current_page: 1,
      sort_by: "",
      order_by: "ASC",
    },
  });
  useEffect(() => {
    fetchBlog(false, pagination);
    fetchServiceDdl(setServicesDdl);
    handleHasTrainerBankInfo(setHasBankInfo, setLoadingBankInfoDetails);
  }, [selectedRelationId, showHistoricalCheck]);

  const handleCloseForm = (status: boolean) => {
    setShowForm(false);
    if (trainerAvailabilityToEdit) {
      setTrainerAvailabilityToEdit(undefined);
    }
    if (status) {
      fetchBlog(false, pagination);
    }
  };

  const handleDeleteCfm = async (id: number) => {
    const data = await handleDeleteTrainerAvailability(id);
    if (data) {
      fetchBlog(false, pagination);
    }
  };
  const handleOptionClick = (option: string, selectedId: number) => {
    setSelectedRelationId(selectedId);
  };
  const fetchBlog = (append = false, payloadPagination: IPagination) => {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(async () => {
      fetchTrainerAvailabilityApi(
        setTrainerAvailabilityList,
        setLoading,
        selectedRelationId,
        showHistoricalCheck,
        setPagination,
        payloadPagination,
        trainerAvailabilityList,
        append
      );
    }, 500);
  };
  const onScroll = (event: TScrollEvent) => {
    if (listInnerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
      const isNearBottom = scrollTop + clientHeight >= scrollHeight;
      if (
        isNearBottom &&
        trainerAvailabilityList &&
        pagination.total_count > trainerAvailabilityList.length
      ) {
        fetchBlog(true, {
          ...pagination,
          current_page: pagination.current_page + 1,
        });

        event.preventDefault();
      }
    }
  };

  useEffect(() => {
    const listInnerElement = listInnerRef.current;
    if (listInnerElement) {
      listInnerElement.addEventListener(
        "scroll",
        onScroll as unknown as EventListener
      );
      return () => {
        listInnerElement.removeEventListener(
          "scroll",
          onScroll as unknown as EventListener
        );
      };
    }
  }, [pagination]);

  const handleOpenForm = () => {
    if (!hasBankInfo) {
      Swal.fire({
        titleText: t("bank_info"),
        text: t("bank_info_required"),
        showCancelButton: true,
        confirmButtonText: t("add"),
      }).then(function (result) {
        if (result.isConfirmed) {
          navigate(routeTrainer.trainerBankInfo);
        }
      });
    } else {
      setShowForm(true);
    }
  };

  return (
    <>
      <div className="flex flex-col pb-3 overflow-hidden h-svh md:h-[calc(100vh-76px)]">
        <div className="comman-padding ">
          <BackButton />
        </div>
        <div className="flex items-center flex-col flex-1 overflow-hidden ">
          <div className="w-11/12 lg:w-1/2 rounded-lg h-full flex flex-col pb-3 bg-skin-grey-bg">
            <div className=" comman-padding space-y-2 ">
              <div className="comman-black-big">
                <p>{t("my_availability")}</p>
              </div>
              <div className=" flex justify-between">
                <div className="w-full">
                  <ICDropDown
                    label={t("select_your_offering")}
                    selected={
                      selectedRelationId ? selectedRelationId : undefined
                    }
                    className={"w-full"}
                    options={servicesDdl.map((data) => ({
                      label: data.display_value,
                      value: data.data_value,
                    }))}
                    onSelect={(option) => {
                      handleOptionClick(option.label, option.value);
                    }}
                    searchable
                    showBlank
                  />
                </div>

                <div className="ml-3">
                  {!loadingBankInfoDetails && (
                    <ICButton
                      className="!rounded-full !p-0"
                      onClick={handleOpenForm}
                    >
                      <div className="h-8 w-8 cursor-pointer rounded-full border">
                        {addCertificateIcon}
                      </div>
                    </ICButton>
                  )}
                </div>
              </div>
              {/* for future update */}
              {/* <div className="flex ">
                <ICCheckbox
                  id={`checkbox`}
                  name="framework_consent"
                  checked={showHistoricalCheck}
                  onChange={(e) =>
                    setShowHistoricalCheckCheck(e.target.checked)
                  }
                  label={t("show_historical_record")}
                />
              </div> */}
            </div>
            {loading ? (
              <Loader />
            ) : (
              <div className="overflow-y-scroll flex-1" ref={listInnerRef}>
                {trainerAvailabilityList &&
                trainerAvailabilityList.length > 0 ? (
                  trainerAvailabilityList.map((item, index) => {
                    return (
                      <div
                        key={index}
                        className="grid grid-cols-12 mx-3 border-2  mb-3 comman-padding  break-words "
                      >
                        <div className="col-span-12 flex justify-between mb-2">
                          <div>
                            {item.is_available === BIT_VALUE.One ? (
                              <div className="text-skin-payment-successful">
                                {t("available")}
                              </div>
                            ) : (
                              <div className="text-skin-payment-cancelled">
                                {t("not_available")}
                              </div>
                            )}
                          </div>
                          <div className="flex space-x-2 items-center">
                            <div
                              className="h-4 w-4 cursor-pointer"
                              onClick={() => {
                                setShowForm(true);
                                setTrainerAvailabilityToEdit(item);
                              }}
                            >
                              {editProfileIcon}
                            </div>
                            <div
                              className="h-5 w-5 cursor-pointer"
                              title={t("delete_tooltip_icon")}
                            >
                              <ICSweetAlertModal
                                title={t("would_you_like_proceed")}
                                text={t("your_slot_delete")}
                                onConfirm={handleDeleteCfm}
                                itemId={item.id}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-span-4 comman-black-text">
                          {t("services")}
                        </div>
                        <div className="col-span-8 comman-black-text">
                          {item.service_title}
                        </div>
                        <div className="col-span-4 comman-black-text">
                          {t("peer_to_peer")}
                        </div>
                        <div className="col-span-8 comman-black-text">
                          <p className="comman-black-text">
                            {item?.is_peer_to_peer === BIT_VALUE.One
                              ? `${t("yes")}`
                              : `${t("no")}`}
                          </p>
                        </div>
                        <div className="col-span-4 comman-black-text">
                          {t("gender_specific")}
                        </div>
                        <div className="col-span-8 comman-black-text">
                          <p className="comman-black-text">
                            {item?.is_gender_specific === BIT_VALUE.One
                              ? `${t("yes")}`
                              : `${t("no")}`}
                          </p>
                        </div>

                        {/*   for future update */}
                        {/* <div className="col-span-4 comman-black-text">
                          {t("from_date")}
                        </div>
                        <div className="col-span-8 comman-black-text">
                          {dateFormat(getLocalDate(item.start_date))}
                        </div>
                        <div className="col-span-4 comman-black-text">
                          {t("to_date")}
                        </div>
                        <div className="col-span-8 comman-black-text">
                          {dateFormat(getLocalDate(item.end_date))}
                        </div> */}
                        <div className="col-span-4 comman-black-text">
                          {t("services_duration")}
                        </div>
                        <div className="col-span-8 comman-black-text">
                          {item.service_duration} {item.unit_type_text}
                        </div>
                        <div className="col-span-4 comman-black-text">
                          {t("session_duration")}
                        </div>
                        <div className="col-span-8 comman-black-text">
                          {item.session_duration}&nbsp;{t("min")}
                        </div>
                        <div className="col-span-4 comman-black-text">
                          {t("total_selected_slot")}
                        </div>
                        <div className="col-span-8 comman-black-text">
                          {item.total_selected_slot}
                        </div>
                        <div className="col-span-4 comman-black-text">
                          {t("modified_date")}
                        </div>
                        <div className="col-span-8 comman-black-text">
                          {item.modified_date
                            ? dateFormat(getLocalDate(item.modified_date))
                            : "-"}
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <NoData title={t("availability")} height={75} width={75} />
                )}
              </div>
            )}
          </div>
          {showForm && (
            <TrainerAvailabilityFormView
              handleClose={handleCloseForm}
              trainerAvailabilityToEdit={trainerAvailabilityToEdit}
              showForm={showForm}
              setShowForm={setShowForm}
            />
          )}
          {showForm && <div className="model-disable"></div>}
        </div>
      </div>
    </>
  );
};

export default TrainerAvailabilityView;
